import { build } from "./build";

export const customersQueryParamsLsKey = 'yetirent-customers-qp-' + build;
export const holidayPeriodsQueryParamsLsKey = 'yetirent-holiday-periods-qp-' + build;
export const inventoryItemsQueryParamsLsKey = 'yetirent-inventory-items-qp-' + build;
export const reservationsQueryParamsLsKey = 'yetirent-reservations-qp-' + build;
export const usersQueryParamsLsKey = 'yetirent-users-qp-' + build;
export const yetiRentUserInfoLsKey = 'yetirent-user-info' + build;